module.exports = __webpack_public_path__ + "static/media/about-plan.f95ca27b.jpg";